import clsx from 'clsx'

import { Col } from './col'
import { Row } from './row'

import '@cosmos/grid/grid.css'
import { GridProps } from './grid.types'

const Grid = ({ children, className, 'data-test': dataTest, fluid = false }: GridProps) => {
  const classes = clsx({ 'hot-container-fluid': fluid, 'hot-container': !fluid }, className)

  return (
    <div data-test={dataTest} className={classes}>
      {children}
    </div>
  )
}

Grid.Row = Row
Grid.Col = Col

export default Grid
